import Vue from 'vue';
import VueI18n from 'vue-i18n';

// import { getLanguage } from '@tencent/s2-client-vue-lib';

// element-ui built-in lang
import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN';

// User defined lang
import enLocale from './LangEn';
import zhLocale from './LangZh';
import { getJarvisLocale, setJarvisLocale } from '@/libs/LibsLocate';

Vue.use(VueI18n);

/** message */
const messages: any = {
	en: {
		...enLocale,
		...elementEnLocale
	},
	zh: {
		...zhLocale,
		...elementZhLocale
	}
};

/** locale */
export const getLocale: any = (): any => {
	const cookieLanguage: any = getJarvisLocale();
	console.log('cookieLanguage: ----------------------', cookieLanguage);

	if (cookieLanguage) {
		document.documentElement.lang = cookieLanguage;

		// 兼容之前的currentLanguage
		return cookieLanguage === 'zh_CN' ? 'zh' : 'en';
	}

	setJarvisLocale('en_US');

	// const language: any = navigator.language.toLowerCase();
	// const locales: any = Object.keys(messages);

	// for (const locale of locales) {
	// 	if (language.indexOf(locale) > -1) {
	// 		document.documentElement.lang = locale;
	// 		console.log(locale, 'locales');

	// 		return locale;
	// 	}
	// }

	// Default language is english
	// 'zh';

	return 'en';
};

/** i18n */
const i18n: any = new VueI18n({
	locale: getLocale(),
	messages
});

export default i18n;
